import { flow3tazazxj2t7g4 as flow } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  captureStack1fzi4aczwc4hg as captureStack,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function transformWhile(_this__u8e3s4, transform) {
  return flow(transformWhile$slambda(_this__u8e3s4, transform));
}
var AbortFlowExceptionClass;
function AbortFlowException() {
  if (AbortFlowExceptionClass === VOID) {
    class $ extends CancellationException() {
      constructor(owner) {
        return new.target.c64(owner);
      }
      static c64(owner) {
        var $this = this.n('Flow was aborted, no more elements needed');
        captureStack($this, $this.b64_1);
        $this.a64_1 = owner;
        return $this;
      }
      d64(owner) {
        if (!(this.a64_1 === owner))
          throw this;
      }
    }
    initMetadataForClass($, 'AbortFlowException');
    AbortFlowExceptionClass = $;
  }
  return AbortFlowExceptionClass;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.e64_1 = function_0;
      }
      *v1d(value, $completion) {
        return yield* this.e64_1(value, $completion);
      }
      i5() {
        return this.e64_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var transformWhile$1$$inlined$collectWhile$1Class;
function transformWhile$1$$inlined$collectWhile$1() {
  if (transformWhile$1$$inlined$collectWhile$1Class === VOID) {
    class $ {
      constructor($transform, $this_flow) {
        this.f64_1 = $transform;
        this.g64_1 = $this_flow;
      }
      *v1g(value, $completion) {
        if (!(yield* this.f64_1(this.g64_1, value, $completion))) {
          throw AbortFlowException().c64(this);
        }
        return Unit_instance;
      }
      v1d(value, $completion) {
        return this.v1g(value, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [FlowCollector()], [1]);
    transformWhile$1$$inlined$collectWhile$1Class = $;
  }
  return transformWhile$1$$inlined$collectWhile$1Class;
}
function transformWhile$slambda$slambda($collector) {
  return constructCallableReference(function *(it, $completion) {
    yield* $collector.v1g(it, $completion);
    return Unit_instance;
  }, 1);
}
function transformWhile$slambda($this_transformWhile, $transform) {
  return constructCallableReference(function *($this$flow, $completion) {
    // Inline function 'com.apollographql.apollo.internal.collectWhile' call
    var this_0 = $this_transformWhile;
    var collector = new (transformWhile$1$$inlined$collectWhile$1())($transform, $this$flow);
    try {
      var tmp = transformWhile$slambda$slambda(collector);
      yield* this_0.y1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
    } catch ($p) {
      if ($p instanceof AbortFlowException()) {
        var e = $p;
        e.d64(collector);
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }, 1);
}
//region block: exports
export {
  transformWhile as transformWhile1eyv77fe96rjt,
};
//endregion

//# sourceMappingURL=flows.mjs.map
